export default "__VITE_ASSET__D0Oru5bg__"